import { Ban, CheckCircle2, CircleAlert, Loader2, MicOff, ShieldOff } from 'lucide-react';
import type { AudioDeviceState } from 'utils/audio/audioDeviceTypes';

export const STATE_ICONS: Record<AudioDeviceState, typeof CircleAlert> = {
  searching: Loader2,
  recommendedConnected: CheckCircle2,
  confirmedConnected: CheckCircle2,
  recommendedMissing: CircleAlert,
  recommendedNeverSeen: CircleAlert,
  confirmedMissing: CircleAlert,
  recommendedInaccessible: Ban,
  confirmedInaccessible: Ban,
  accessBlocked: ShieldOff,
  noDevice: MicOff,
};
